import React from 'react';
import BigHeroBlock from '../common/components/BigHeroBlock';

export default function BigHeroPanel({ panel }: {panel: any}) {
  // eslint-disable-next-line react/jsx-props-no-spreading
  return (<BigHeroBlock {...{ ...panel }} />);
}
